// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W1kDPWy1jxeoHOyHPPhg,
.Clwc7Ij_OGvVvA6muVMf {
  display: flex;
}

.W1kDPWy1jxeoHOyHPPhg .W3V7GhHQBQWw8knQeQEQ {
  width: 48px;
  height: 48px;
}
.W1kDPWy1jxeoHOyHPPhg .NJ9SnB8lnWPgD4ACKOD9 {
  flex: 0 0 calc(100% - 48px);
  width: calc(100% - 48px);
  padding-left: 16px;
}
.W1kDPWy1jxeoHOyHPPhg:not(:first-child) {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #EFEFEF;
}
.dark-mode .W1kDPWy1jxeoHOyHPPhg:not(:first-child) {
  border-color: #272B30;
}

.Clwc7Ij_OGvVvA6muVMf {
  margin-top: 32px;
  padding: 24px 0 0 64px;
  border-top: 1px solid #EFEFEF;
}
.dark-mode .Clwc7Ij_OGvVvA6muVMf {
  border-color: #272B30;
}

.Clwc7Ij_OGvVvA6muVMf .W3V7GhHQBQWw8knQeQEQ {
  width: 32px;
  height: 32px;
}
.Clwc7Ij_OGvVvA6muVMf .NJ9SnB8lnWPgD4ACKOD9 {
  flex: 0 0 calc(100% - 32px);
  width: calc(100% - 32px);
  padding-left: 16px;
}

.W3V7GhHQBQWw8knQeQEQ {
  flex-shrink: 0;
}
.W3V7GhHQBQWw8knQeQEQ img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.jpJ7PX_9myUlbRynEPCX {
  display: flex;
  align-items: center;
}

.BiaQOkUsHDHDJeY_lujH {
  margin-right: auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vmTF2iMdiIRBqB0v2frF {
  margin-left: 8px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3333333333;
  font-weight: 500;
  color: #9A9FA5;
}

.rE12VdkT6xx2U62Gg4HR {
  display: flex;
  align-items: center;
  margin-left: 16px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
}
.rE12VdkT6xx2U62Gg4HR svg {
  margin-left: 8px;
  fill: #FFC554;
}

.SV8_d7ePG9zoc9qjSDzT {
  margin-top: 4px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2307692308;
  font-weight: 500;
  color: #6F767E;
}

.Te7MAfuycJIeBy88aL56 {
  margin-top: 12px;
  font-weight: 500;
  color: #33383F;
}
.dark-mode .Te7MAfuycJIeBy88aL56 {
  color: #FCFCFC;
}

.Te7MAfuycJIeBy88aL56 strong {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/ModalProduct/Product/Comments/Item/Item.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;;EAEI,aAAA;AADJ;;AAII;EACI,WAAA;EACA,YAAA;AADR;AAEI;EACI,2BAAA;EACA,wBAAA;EACA,kBAAA;AAAR;AACI;EACI,gBAAA;EACA,iBAAA;EACA,6BAAA;AACR;AC0Ka;EDzKD,qBC2BP;ADzBL;;AAAA;EACI,gBAAA;EACA,sBAAA;EACA,6BAAA;AAGJ;ACiKa;EDlKL,qBCoBH;ADhBL;;AAHI;EACI,WAAA;EACA,YAAA;AAMR;AALI;EACI,2BAAA;EACA,wBAAA;EACA,kBAAA;AAOR;;AALA;EACI,cAAA;AAQJ;AAPI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AASR;;AAPA;EACI,aAAA;EACA,mBAAA;AAUJ;;AARA;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAWJ;;AATA;EACI,gBAAA;EACA,mBAAA;ECiEA,eAAA;EACA,gBAAA;EACA,yBAAA;EDjEA,gBAAA;EACA,cCRM;ADsBV;;AAZA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;ECyBA,eAAA;EACA,gBAAA;EACA,yBAAA;ADTJ;AAhBI;EACI,gBAAA;EACA,aAAA;AAkBR;;AAhBA;EACI,eAAA;ECwCA,eAAA;EACA,gBAAA;EACA,yBAAA;EDxCA,gBAAA;EACA,cC7BC;ADkDL;;AAnBA;EACI,gBAAA;EACA,gBAAA;EACA,cCjCC;ADuDL;ACwFa;ED5GL,cCvCH;AD8DL;;AAtBI;EACI,gBAAA;AAyBR","sourcesContent":["@import ../../../../../styles/helpers\n\n.item,\n.answer\n    display: flex\n\n.item\n    .avatar\n        width: 48px\n        height: 48px\n    .details\n        flex: 0 0 calc(100% - 48px)\n        width: calc(100% - 48px)\n        padding-left: 16px\n    &:not(:first-child)\n        margin-top: 32px\n        padding-top: 24px\n        border-top: 1px solid $n3\n        +dark\n            border-color: $n6\n\n.answer\n    margin-top: 32px\n    padding: 24px 0 0 64px\n    border-top: 1px solid $n3\n    +dark\n        border-color: $n6\n    .avatar\n        width: 32px\n        height: 32px\n    .details\n        flex: 0 0 calc(100% - 32px)\n        width: calc(100% - 32px)\n        padding-left: 16px\n\n.avatar\n    flex-shrink: 0\n    img\n        width: 100%\n        height: 100%\n        border-radius: 50%\n        object-fit: cover\n\n.line\n    display: flex\n    align-items: center\n\n.author\n    margin-right: auto\n    white-space: nowrap\n    overflow: hidden\n    text-overflow: ellipsis\n\n.time\n    margin-left: 8px\n    white-space: nowrap\n    +caption2\n    font-weight: 500\n    color: $shades1\n\n.rating\n    display: flex\n    align-items: center\n    margin-left: 16px\n    +base2\n    svg\n        margin-left: 8px\n        fill: #FFC554\n\n.login\n    margin-top: 4px\n    +caption1\n    font-weight: 500\n    color: $n4\n\n.comment\n    margin-top: 12px\n    font-weight: 500\n    color: $n5\n    +dark\n        color: $n1\n    strong\n        font-weight: 600","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `W1kDPWy1jxeoHOyHPPhg`,
	"answer": `Clwc7Ij_OGvVvA6muVMf`,
	"avatar": `W3V7GhHQBQWw8knQeQEQ`,
	"details": `NJ9SnB8lnWPgD4ACKOD9`,
	"line": `jpJ7PX_9myUlbRynEPCX`,
	"author": `BiaQOkUsHDHDJeY_lujH`,
	"time": `vmTF2iMdiIRBqB0v2frF`,
	"rating": `rE12VdkT6xx2U62Gg4HR`,
	"login": `SV8_d7ePG9zoc9qjSDzT`,
	"comment": `Te7MAfuycJIeBy88aL56`
};
export default ___CSS_LOADER_EXPORT___;
